import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface AssetListSharedState {
  isEditing: boolean;
  company: string;
  selectedMilestone: any;
  isFilterVideoActive: boolean;
  isFilterStillActive: boolean;
  selectedProjectAssetListIds: any[];
  displayedAssetList: any;
  editModal: any;
  selectedAssetTypes: any[];
  selectedAssetId: any[];
  selectedCategory: string[];
  first_consideration_asset: string;
  first_conversion_asset: string;
  first_awarness_asset: string;
  funnelList: any[];
  allBundle: any[];
  allAssets: any[];
  isBusy: boolean;
  affectedAssets: any;
  draggedCard: any;
  targetCardId: any;
  isInMoveToSelectOptions: boolean;
  showHiddenAssets: boolean;
  cacheBuster: string;
  projects: any;
  hiddenAssetToggleState: { [key: string]: boolean };
}

@Injectable({
  providedIn: 'root',
})
export class AssetListStateService {
  private readonly initialState: AssetListSharedState = {
    isEditing: true,
    company: 'cpd',
    selectedMilestone: null,
    isFilterVideoActive: false,
    isFilterStillActive: false,
    selectedProjectAssetListIds: [],
    displayedAssetList: null,
    editModal: null,
    selectedAssetTypes: [],
    selectedAssetId: [],
    selectedCategory: [],
    first_consideration_asset: '',
    first_conversion_asset: '',
    first_awarness_asset: '',
    funnelList: [],
    allBundle: [],
    allAssets: [],
    isBusy: false,
    affectedAssets: {},
    draggedCard: null,
    targetCardId: null,
    isInMoveToSelectOptions: false,
    showHiddenAssets: true,
    cacheBuster: new Date().getTime().toString(),
    projects: {},
    hiddenAssetToggleState: {},
  };

  private readonly stateSubject: BehaviorSubject<AssetListSharedState> = new BehaviorSubject<AssetListSharedState>(
    this.initialState
  );

  /**
   * Observable stream of the entire state
   */
  readonly state$: Observable<AssetListSharedState> = this.stateSubject.asObservable();

  /**
   * Get the current state snapshot
   */
  get currentState(): AssetListSharedState {
    return this.stateSubject.getValue();
  }

  /**
   * Universal update method - updates any field(s) dynamically
   * @param patch - Partial state object with properties to update
   */
  public updateState(patch: Partial<AssetListSharedState>): void {
    const currentState: AssetListSharedState = this.stateSubject.getValue();
    const newState: AssetListSharedState = { ...currentState, ...patch };
    this.stateSubject.next(newState);
  }

  public resetComponentState(): void {
    this.updateState({
      isEditing: true,
      selectedMilestone: null,
      isFilterVideoActive: false,
      isFilterStillActive: false,
      selectedProjectAssetListIds: [],
      displayedAssetList: null,
      editModal: null,
      selectedAssetTypes: [],
      selectedAssetId: [],
      selectedCategory: [],
      draggedCard: null,
      targetCardId: null,
      isBusy: false,
    });
  }
}
